import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers";
import reduxSubscribeMiddleware from "middlewares/ReduxSubscribeMiddleware";
const store = createStore(reducers, applyMiddleware(reduxSubscribeMiddleware, thunk));
export default store;
